import React, { useCallback, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import styled, { css } from "styled-components";
import useHistory from "routing/useHistory";
import CollectionDetails from "collections/components/CollectionDetails";
import { Button, ButtonToolbar, Row, Alert } from "components/bootstrap";
import { DocumentTitle, Icon, IfPermitted, PageHeader, ShareButton, Spinner } from "components/common";
import useParams from "routing/useParams";
import useCollection from "collections/hooks/useCollection";
import EntityShareModal from "components/permissions/EntityShareModal";
import { COLLECTIONS_QUERY_KEY } from "collections/hooks/useCollections";
import UpdateCollectionButton from "collections/components/UpdateCollectionButton";
import CollectionsRoutes from "../Routes";
const HeaderTitle = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.sm};
    margin-bottom: ${theme.spacings.xs};
  `
);
const StyledInfoList = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xs};
    margin-bottom: ${theme.spacings.xs};
    margin-left: ${theme.spacings.xs};
    list-style-type: none;
  `
);
const CollectionDetailsPage = () => {
  const queryClient = useQueryClient();
  const { push } = useHistory();
  const params = useParams();
  const [showCollectionShareModal, setShowCollectionShareModal] = useState(false);
  const toggleCollectionShareModal = () => setShowCollectionShareModal(!showCollectionShareModal);
  const { data: collection, isLoading } = useCollection(params.collectionId, { enabled: !!params.collectionId });
  const collectionTitle = (collection == null ? void 0 : collection.title) ? `Collection ${collection.title}` : "Collection";
  const refetchCollection = useCallback(
    () => queryClient.invalidateQueries({
      queryKey: [COLLECTIONS_QUERY_KEY, collection == null ? void 0 : collection.id]
    }),
    [queryClient, collection == null ? void 0 : collection.id]
  );
  const handleShareClose = () => {
    refetchCollection();
    toggleCollectionShareModal();
  };
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: collectionTitle }, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: /* @__PURE__ */ React.createElement(HeaderTitle, null, /* @__PURE__ */ React.createElement(Button, { onClick: () => push(CollectionsRoutes.LIST) }, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_left_alt", size: "sm" }), " Back"), collectionTitle),
      topActions: collection && /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `collections:edit:${collection.id}` }, /* @__PURE__ */ React.createElement(UpdateCollectionButton, { editCollection: collection, buttonText: "Edit" })), /* @__PURE__ */ React.createElement(
        ShareButton,
        {
          entityId: collection.id,
          entityType: "collection",
          onClick: toggleCollectionShareModal,
          title: "Manage"
        }
      ))
    },
    (collection == null ? void 0 : collection.description) ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", null, collection == null ? void 0 : collection.description), " ", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info", title: "Page Information" }, /* @__PURE__ */ React.createElement(StyledInfoList, null, /* @__PURE__ */ React.createElement("li", null, "The content, membership, management and configuration of a Collection can be managed from this page."), /* @__PURE__ */ React.createElement("li", null, "Sharing Collection Content with a user grants them permission to the sharable entities within."), /* @__PURE__ */ React.createElement("li", null, "To modify the content of this Collection, or the permission level the Collection grants to content, a user must first be granted permission to Manage that Collection.")))) : /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, /* @__PURE__ */ React.createElement(StyledInfoList, null, /* @__PURE__ */ React.createElement("li", null, "The content, membership, management and configuration of a Collection can be managed from this page."), /* @__PURE__ */ React.createElement("li", null, "Sharing Collection Content with a user grants them permission to the sharable entities within."), /* @__PURE__ */ React.createElement("li", null, "To modify the content of this Collection, or the permission level the Collection grants to content, a user must first be granted permission to Manage that Collection.")))
  ), isLoading && /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading collection..." })), collection && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CollectionDetails, { collection }), showCollectionShareModal && /* @__PURE__ */ React.createElement(
    EntityShareModal,
    {
      entityId: collection.id,
      entityType: "collection",
      entityTitle: collection.title,
      description: "Search for a User or Team to add as collaborator on this Collection.",
      onClose: handleShareClose
    }
  )));
};
export default CollectionDetailsPage;
